<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <b-button v-on:click="goBack" variant="secondary">
                    <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h1>Bulk Template Edit</h1>
            </b-col>
        </b-row>
        <div v-if="sourceSelectionMode" class="viewMode">
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Templates</strong>
                        </div>                        
                        <TemplateListSelection v-on:templates-selected="templatesSelected" :current-selected="selectedTemplates" />
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="dataEditMode" class="viewMode">
            <TemplateEditForm v-on:apply-data="templateDataCommit" />
        </div>
        <div v-if="committingDataMode" class="viewMode">
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Updating Templates</strong>
                        </div>
                        <div class="form-container">
                            <p>
                                The following templates will be updated:
                            </p>
                            <b-row>
                                <b-col sm="12">
                                    <div class="mb-3">
                                        <strong>Template Name</strong>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-for="template in selectedTemplates" v-bind:key="template.id" class="output-row">
                                <b-col sm="12">
                                    <b-input-group>
                                        <b-form-input
                                            v-model="template.template_name"
                                            type="text"
                                            class="form-control"
                                            :id="'template-' + template.id"
                                            readonly
                                        ></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="form-container">
                            <p>
                                The following template fields will be updated with the displayed value.
                            </p>
                            <b-row>
                                <b-col sm="6">
                                    <div class="mb-3">
                                        <strong>Field</strong>
                                    </div>
                                </b-col>
                                <b-col sm="6">
                                    <div class="mb-3">
                                        <strong>New Value</strong>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-for="templateField in templateItems" v-bind:key="templateField.field" class="output-row">
                                <b-col sm="6">
                                    <b-input-group>
                                        <b-form-input
                                            v-model="templateField.field"
                                            type="text"
                                            class="form-control"
                                            :id="'template-' + templateField.field"
                                            readonly
                                        ></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-input-group>
                                        <b-form-input
                                            v-model="templateField.value"
                                            type="text"
                                            class="form-control"
                                            :id="'template-' + templateField.field + '-' + templateField.value"
                                            readonly
                                        ></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="form-container">                    
                            <h4>Working...</h4>
                            <b-progress :value="dataCommitProgress" :max="dataCommitMax" show-progress animated class="mb-3"></b-progress>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="commitComplete" class="viewMode">
            <b-alert variant="success" show><strong>Complete</strong></b-alert>
        </div>
        
    </div>
</template>

<script>

import TemplateListSelection from '../../components/data-control/templates/TemplateListSelection.vue';
import TemplateEditForm from '../../components/data-control/templates/TemplateEditForm.vue';
import TemplatesService from '@/services/templates-service.js';

export default {
  name: 'templates',
  components: {
      TemplateListSelection: TemplateListSelection,
      TemplateEditForm: TemplateEditForm
  },
  data () {
    return {
        sourceSelectionMode: true,
        dataEditMode: false,
        committingDataMode: false,
        dataCommitProgress: 0,
        dataCommitMax: 0,
        selectedTemplates: [],
        templateItems: [],
        commitComplete: false
    }
  },
  methods: {
    goBack() {
        if (this.$data.dataEditMode) {
            this.$data.dataEditMode = false;
            this.$data.dataCommitProgress = true;
            this.$data.sourceSelectionMode = true;
        }
        else {
            this.$router.push('/data-control');
        }
        
    },
    templatesSelected(templates) {
        this.$data.selectedTemplates = templates;
        this.$data.dataEditMode = true;
        this.$data.sourceSelectionMode = false;
    },
    async templateDataCommit(sentTemplateData) {

        console.log(sentTemplateData);
        let self = this;
        this.$data.selectedTemplates = this.$data.selectedTemplates.filter((item) => {
            return item.itemSelected;
        });

        Object.keys(sentTemplateData).forEach(function(key) {
            self.$data.templateItems.push({'field': key, 'value': sentTemplateData[key]});
        });
        this.$data.dataEditMode = false;
        this.$data.committingDataMode = true;
        this.$data.dataCommitMax = this.$data.selectedTemplates.length;

        // send the data to the api
        this.$data.dataCommitProgress = 0;
        for (let templateNumber = 1; templateNumber <= this.$data.selectedTemplates.length; templateNumber++) {
            let templateToSend = JSON.parse(JSON.stringify(this.$data.selectedTemplates[templateNumber - 1]));
            
            // // update the fields
            // Object.keys(sentTemplateData).forEach(function(key) {
            //     templateToSend[key] = sentTemplateData[key];
            // });

            await TemplatesService.updateTemplate(sentTemplateData, templateToSend.id);
            this.$data.dataCommitProgress++;
        };

        // flag the process as complete
        setTimeout(() => {
            this.$data.committingDataMode = false;
            this.$data.commitComplete = true;
        }, 1000);
        setTimeout(() => {
            this.$router.push('/data-control');
        }, 3000);

    }
  }
}
</script>

<style scoped>
.row.output-row {
    padding-bottom: 8px;
}
</style>